import { useLocation, useNavigate, useParams } from "react-router-dom-v5-compat";

export function withRouter(Component: any): any {
    return (props: any) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        const queryParams = new URLSearchParams(location.search);
        return <Component {...props} router={{ location, navigate, params, queryParams }} />;
    };
}
